module.exports = {"id":"211239","name":"Corentin Jean","rating":"74","photo":"./data/images/photos/3/211239.png","club":{"name":"Toulouse FC","logo":"./data/images/clubs/ToulouseFC.png"},"positions":["MD","MG","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CorentinJean0.json
// module id = 854
// module chunks = 0